/**
 * Type of reference to another News(35=B) message item.
 * tag: 1477
 * @readonly
 * @enum {number} (int)
 */
export enum NewsRefType {
  /** Replacement */
  Replacement = 0,
  /** Other language */
  OtherLanguage = 1,
  /** Complimentary */
  Complimentary = 2,
  Withdrawal = 3,
}
